export const PO_ACCEPTED = 'PO_ACCEPTED';
export const PO_UPDATED = 'PO_UPDATED';
export const PO_CREATED = 'PO_CREATED';
